var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'form-group c-input-relation-multiple',
    { 'form-group--inline': _vm.inline }
  ]},[_c('label',{staticClass:"form__label",attrs:{"for":_vm.slug}},[_vm._v(_vm._s(_vm.label))]),_c('v-select',{attrs:{"value":_vm.selectValue,"options":_vm.computedOptions,"label":"label","multiple":true},on:{"input":_vm.onChange}}),(_vm.hasError)?_c('InputError',{attrs:{"message":_vm.errorMessage}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }